import React from 'react'
import { IssueEntity } from '../../../types/IssueEntity'
import { valueFormatter } from './utils'
import { useTheme } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { CommitChart } from './CommitChart'

export const CommitChartWithNoInvestors = ({
    approxCommitment,
    approxGuarantor,
    approxTotalCommitment,
}: {
    approxCommitment: IssueEntity['approxCommitment']
    approxGuarantor: IssueEntity['approxGuarantor']
    approxTotalCommitment: IssueEntity['approxTotalCommitment']
}) => {
    const theme = useTheme()
    const { i18n } = useTranslation()
    const locale = i18n.language

    if (approxTotalCommitment || (!approxCommitment && !approxGuarantor)) return null

    let apCommitment = parseFloat(approxCommitment)
    let apGuarantor = parseFloat(approxGuarantor)
    let totalCommitment = apCommitment + apGuarantor

    if (totalCommitment > 100) {
        // Normalize to 100%, so that the chart does not collapse
        apCommitment = (100 * apCommitment) / totalCommitment
        apGuarantor = (100 * apGuarantor) / totalCommitment
        totalCommitment = 100
    }

    const series = [
        {
            stack: 'A',
            label: 'Teckningsåtagande',
            data: [apCommitment],
            valueFormatter: valueFormatter(locale),
            color: theme.palette.info.main,
        },
        {
            stack: 'A',
            label: 'Garantiåtagande',
            data: [apGuarantor],
            valueFormatter: valueFormatter(locale),
            color: theme.palette.info.light,
        },
    ]

    if (apCommitment + apGuarantor < 100) {
        series.push({
            stack: 'A',
            label: 'Ej säkerställt',
            data: [100 - (apCommitment + apGuarantor)],
            valueFormatter: valueFormatter(locale),
            color: theme.palette.grey[200],
        })
    }

    return <CommitChart series={series} locale={locale} />
}
